import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import API from '../../../utils/API';

const REQUEST_STATUSES = [
	{ key: 'Draft',     label: 'Draft',     color: '#868e96', description: 'Still being prepared' },
	{ key: 'Active',    label: 'Active',    color: '#009da0', description: 'Out for proposals' },
	{ key: 'Awarded',   label: 'Awarded',   color: '#0cc27e', description: 'Venue selected' },
	{ key: 'Closed',    label: 'Closed',    color: '#343a40', description: 'Complete — archived' },
	{ key: 'Cancelled', label: 'Cancelled', color: '#ff586b', description: 'No longer moving forward' }
];

/**
 * Compact, editable request-level status pill.
 * Sits in the left rail so the user can always see and change the overall
 * state of the proposal request.
 */
class RequestStatusControl extends React.Component {
	state = { saving: false };

	update = async (nextStatus) => {
		const { orgId, requestId, status, onUpdated } = this.props;
		if (nextStatus === status) return;

		this.setState({ saving: true });
		try {
			await API().patch(
				`Organizations/${orgId}/proposal-requests/${requestId}`,
				{ status: nextStatus }
			);
			onUpdated && onUpdated(nextStatus);
		} catch (e) {
			console.error('Error updating request status:', e);
		}
		this.setState({ saving: false });
	};

	render() {
		const { status } = this.props;
		const { saving } = this.state;
		const current = REQUEST_STATUSES.find(s => s.key === status) || REQUEST_STATUSES[0];

		return (
			<UncontrolledDropdown className="requestStatusControl">
				<DropdownToggle
					tag="button"
					className="requestStatusToggle"
					style={{
						display: 'flex',
						alignItems: 'center',
						gap: 8,
						padding: '6px 12px',
						borderRadius: 999,
						border: `1px solid ${current.color}40`,
						background: `${current.color}14`,
						color: current.color,
						fontWeight: 600,
						fontSize: 12,
						width: '100%',
						cursor: 'pointer'
					}}
					disabled={saving}
				>
					<span
						style={{
							width: 8,
							height: 8,
							borderRadius: '50%',
							background: current.color,
							flexShrink: 0
						}}
					/>
					<span style={{ flex: 1, textAlign: 'left' }}>
						{saving ? 'Saving…' : current.label}
					</span>
					<i className="las la-angle-down" style={{ fontSize: 12, opacity: 0.7 }} />
				</DropdownToggle>
				<DropdownMenu  style={{ minWidth: 220, padding: 5 }}>
					{REQUEST_STATUSES.map(s => (
						<DropdownItem
							key={s.key}
							onClick={() => this.update(s.key)}
							active={s.key === status}
							style={{ padding: '8px 12px', gap: 10, whiteSpace: 'normal', display: 'flex', alignItems: 'center' }}
						>
							<span
								style={{
									width: 8,
									height: 8,
									borderRadius: '50%',
									background: s.color,
									flexShrink: 0
								}}
							/>
							<div style={{ flex: 1 }}>
								<div style={{ fontWeight: 600, fontSize: 13 }}>{s.label}</div>
								<div style={{ fontSize: 11, color: '#888' }}>{s.description}</div>
							</div>
							{s.key === status && (
								<i className="las la-check" style={{ color: s.color }} />
							)}
						</DropdownItem>
					))}
				</DropdownMenu>
			</UncontrolledDropdown>
		);
	}
}

export { REQUEST_STATUSES };
export default RequestStatusControl;
